import { Component, OnInit, ɵConsole } from '@angular/core';
import { SentemailService } from 'src/app/services/sentemail.service';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import emailMask from 'text-mask-addons/dist/emailMask';
@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))

  Username: string;
  Tel: string;
  Email: string;
  TopPic: string;
  Detail: string;

  sentEmailComplete: Boolean = false
  routerLinkVariable = '/home';
  // google map
  lat = 13.7466089
  lng = 100.5318359

  selectList = [
    { title: this.language.contactusform6, value: 'เปิดบัญชีซื้อขาย' },
    { title: this.language.contactusform7, value: 'ข้อมูลกองทุน' },
    { title: this.language.contactusform8, value: 'ร้องเรียน' },
    { title: this.language.contactusform9, value: 'อื่นๆ' },
  ]

  nameReq = false
  telReq = false
  emailReq = false
  emailinvalidPattern = false
  topicReq = false
  detailReq = false

  emailPattern = emailMask
  emailPatternCheck = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  constructor(private _sentemailService: SentemailService, private router: Router, private loader: NgxUiLoaderService) { }

  ngOnInit() {
    // $('#covidModal').modal('show');
  }

  getFundIdFromSelect(event) {
    this.TopPic = event;
  }

  setUsername(UserName: string) {
    this.Username = UserName;
  }

  setTopPic(TopPic: string) {
    this.TopPic = TopPic;
  }

  setDetail(Detail: string) {
    this.Detail = Detail;
  }

  onListChange(fundName) {
    this.TopPic = fundName;
  }

  sentMessage() {

    if (this.Username === undefined || this.Username === '') {
      this.nameReq = true
    } else {
      this.nameReq = false
    }

    if (this.Tel === undefined || this.Tel === '') {
      this.telReq = true
    } else if (this.Tel !== undefined) {
      this.telReq = false
    }

    if (this.Email === undefined || this.Email === '') {
      this.emailReq = true
    } else if (this.Email !== undefined) {
      this.emailReq = false
      if (this.Email.match(this.emailPatternCheck) === null) {
        this.emailinvalidPattern = true
      } else {
        this.emailinvalidPattern = false
      }
    }

    if (this.TopPic === undefined) {
      this.topicReq = true
    } else {
      this.topicReq = false
    }

    if (this.Detail === undefined || this.Detail === '') {
      this.detailReq = true
    } else {
      this.detailReq = false
    }

    if (this.nameReq === false && this.telReq === false &&
      this.emailReq === false && this.emailinvalidPattern === false && this.topicReq === false && this.detailReq === false) {

      this.sendComplete()
    }
  }

  sendComplete() {
    this.loader.start()
    this._sentemailService.setEmail(this.TopPic, this.Username, this.Tel, this.Email, this.Detail).subscribe(response => {
      this.sentEmailComplete = true
      this.loader.stop()
    })
  }

  // closeCovidModal() {
  //   $('#covidModal').modal('hide');
  // }
}
